import { useQuery, useMutation } from "@apollo/client/react";import React, { useEffect, useMemo, useState } from "react";

import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { RadioGroupInput } from '../../../../../../components/radioGroupInput/RadioGroupInput';
import SAVE_REQUERIMIENTOS_ADICIONALES_VISITA_CD, { adaptAdicionalesVisitaInput } from "../../../../../../data/graphQL/mutations/Visitas/saveRequerimientosAdicionales";
import { useVisita } from "../../../../../../context/VisitaContext";

import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";
import { GET_COMBO_RI, adaptRadioCombosRIArray } from "../../../../../../data/graphQL/queries/ResumenIngreso/getSingleComboRI";

export const RequerimientosAdicionales = ({ readOnly, onSaveRef, onExposeFormatted }) => {
  const [formData, setFormData] = useState({});
  const { visita, setVisita } = useVisita();
  const [requerimientosOptions, setRequerimientosOptions] = useState();

  const { data: dataAdicionales } = useQuery(GET_COMBO_RI, {
    variables: { campo: 'Adicionales' }
  });

  useEffect(() => {
    if (!dataAdicionales) return;
    setRequerimientosOptions(adaptRadioCombosRIArray(dataAdicionales));
  }, [dataAdicionales]);    

  const [save] = useMutation(SAVE_REQUERIMIENTOS_ADICIONALES_VISITA_CD);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };

      if (newInput.name === 'idComboRIValorReqAdicional') newInput.options = requerimientosOptions;

      newInput.disabled = readOnly;

      return newInput;
    });

  }, [readOnly, formData, requerimientosOptions]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: { input: adaptAdicionalesVisitaInput(formData) } });

    setVisita((prev) => ({
      ...prev,
      ...formData
    }));
  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'requerimientosAdicionales',
      stepName: 'Requerimientos Adicionales',
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <CardBox>
            <Grid container spacing={2}>
                {formattedInputs.map((input) =>
        <Grid size={{ xs: 12 }} key={input.name}>
                        <RadioGroupInput
            key={input.name}
            inputName={input.name}
            adicionalValues={formData[input.name] || []}
            options={requerimientosOptions}
            onChange={handleChange}
            row={false}
            readOnly={readOnly} />
          
                    </Grid>
        )}
            </Grid>
        </CardBox>);

};

const inputs = [
{
  displayName: '',
  name: 'idComboRIValorReqAdicional',
  type: 'multiple_boolean',
  required: false
}];